import React from 'react';
import { IconProps } from '../types/types';

const STKK: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#4EB7F1"/><path fill="#fff" d="m12.969 3.906-6.094 6.719h2.5l-2.188 5.469 5.938-6.719h-2.187l2.03-5.469Z"/></svg>
);

export default STKK;
